/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface LsqError { 
    /**
     * Error level
     */
    level?: LsqError.LevelEnum;
    message?: string;
    /**
     * The categorization of error, e.g. NotFoundException, BadRequestException, etc.
     */
    type?: LsqError.TypeEnum;
}
export namespace LsqError {
    export type LevelEnum = 'info' | 'warn' | 'error';
    export const LevelEnum = {
        Info: 'info' as LevelEnum,
        Warn: 'warn' as LevelEnum,
        Error: 'error' as LevelEnum
    };
    export type TypeEnum = 'Exception' | 'AuthorizationException' | 'NotFoundException' | 'DataAccessException' | 'ValidationException' | 'ConflictException';
    export const TypeEnum = {
        Exception: 'Exception' as TypeEnum,
        AuthorizationException: 'AuthorizationException' as TypeEnum,
        NotFoundException: 'NotFoundException' as TypeEnum,
        DataAccessException: 'DataAccessException' as TypeEnum,
        ValidationException: 'ValidationException' as TypeEnum,
        ConflictException: 'ConflictException' as TypeEnum
    };
}